import styled, { css, keyframes } from 'styled-components';
import { TLoaderSize } from './hb-loader.types';
import { OFFSET_MAP, SIZE_MAP, STROKE_MAP, TIME_MAP } from './hb-loader.utils';

const dash = (offset: number) => keyframes`
 0% {
    opacity: 0;
  }
  20% {
    opacity: 100;
  }
  80% {
    opacity: 10;
  }
  100% {
    opacity: 0;
  }

  to {
    stroke-dashoffset: ${offset};
  }
`;

export const HearthBeatLoaderSC = styled.div<{
  size: TLoaderSize;
}>`
  display: inline-flex;

  ${({ size }) => {
    const sizes = SIZE_MAP[size];
    const offsets = OFFSET_MAP[size];
    const strokeWidth = STROKE_MAP[size];

    return css`
      width: ${sizes.width}px;
      height: ${sizes.height}px;

      svg {
        polyline {
          fill: none;
          stroke-width: ${strokeWidth}px;
          stroke-linecap: round;
          stroke-linejoin: round;

          &.front {
            stroke-dasharray: ${offsets[0]}, ${offsets[1]};
            stroke-dashoffset: ${offsets[0]};
            animation: ${dash(-offsets[1])} ${TIME_MAP[size]}ms linear infinite;
          }
        }
      }
    `;
  }}
`;
